module.exports = __webpack_public_path__ + "static/media/talk2.f4a12043.png";